import secureLocalStorage from "react-secure-storage";

const KybDetails = ({ id }: { id: string }) => {
  const jwt = secureLocalStorage.getItem("jwt");

  return (
    <div className="flex flex-col gap-3 w-full">
      <p className="text-text-base text-[12px] font-medium">
        User KYB Information
      </p>

      <div className="w-full border border-border-subtle rounded-lg overflow-visible">
        <iframe
          src={`https://kyb.tylt.money/${id}?token=${jwt}`}
          className="w-full h-[100vh] pb-[40px]"
          style={{
            height: "70vh",
            border: "none",
            overflow: "auto",
          }}
          scrolling="yes"
          title="KYB Details"
        />
      </div>
    </div>
  );
};

export default KybDetails;
